import { Style } from '@/components/style';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import StoreUtils from '@/utils/storeInfoUtils';
import { isEmpty } from 'lodash';
import OrderServeType from '@/constants/OrderServeType';

const { alertColor, blackColor, primaryColor, gray3Color } =
  new Style().getUiConfig();

function WelcomeReminder({ selectedServeType, selectedTakeOutServeType }) {
  return (
    <div>
      {selectedServeType === OrderServeType.TAKE_OUT && (
        <div
          className="d-flex"
          style={{ color: '#5292D9', fontSize: '12px', paddingBottom: '10px' }}
        >
          <div style={{ color: '#5292D9', fontSize: '5px', padding: '5px' }}>
            ●
          </div>
          <FormattedMessage id="welcome.timeremind" />
        </div>
      )}

      {selectedServeType === OrderServeType.DELIVERY && (
        <div
          className="d-flex align-items-center"
          style={{ color: '#5292D9', fontSize: '12px', paddingBottom: '10px' }}
        >
          <div style={{ color: '#5292D9', fontSize: '5px', padding: '5px' }}>
            ●
          </div>
          <div>
            <FormattedMessage id="welcome.timeremind.delivery.notice" />
          </div>
        </div>
      )}
    </div>
  );
}

WelcomeReminder.defaultProps = {};

WelcomeReminder.propTypes = {
  selectedServeType: PropTypes.string.isRequired,
  selectedTakeOutServeType: PropTypes.string.isRequired,
};

export default WelcomeReminder;
